import { initLocationsOverviewMap } from '../util/event-location-map';

export default {
  init() {},

  finalize() {
    initLocationsOverviewMap();
  },
};
